import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#A7A7B1",
      d: "M11.334 2.225a6.667 6.667 0 1 1-9.997 5.99l-.003-.216.003-.216a6.667 6.667 0 0 1 9.997-5.558M8.001 4a.667.667 0 0 0-.662.588l-.005.078V8l.006.087c.015.116.06.225.131.318l.058.067 2 2 .063.054a.67.67 0 0 0 .817 0l.063-.055.055-.063a.67.67 0 0 0 0-.817l-.055-.063-1.805-1.805V4.665l-.004-.078A.667.667 0 0 0 8 4",
      style: {"fill":"color(display-p3 .6543 .6543 .6951)","fill-opacity":"1"}
    }, null, -1)
  ])))
}
export default { render: render }